import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { DictionariesOfTypeDto, DictionaryTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/useApiClient.util.ts';

type DictionariesType = Record<DictionaryTypeDto, DictionariesOfTypeDto>;

interface Return {
  dictionaries?: DictionariesType;
  isDictionariesError: boolean;
  isFetchingDictionariesTypes: boolean;
}

export const useGetAllDictionaries = (): Return => {
  const { dictionariesApi } = useApiClient();

  const { data, isError, isLoading } = useQuery<DictionariesType, AxiosError>({
    queryFn: async () => {
      const response = await dictionariesApi.getDictionariesByType();

      return response.data.dictionaryItems as DictionariesType;
    },
    queryKey: [QueryKeyEnum.DICTIONARIES],
  });

  return {
    dictionaries: data,
    isDictionariesError: isError,
    isFetchingDictionariesTypes: isLoading,
  };
};
